<template>
  <div :class="$style.container">
    <div v-if="$slots.header" :class="$style.header">
      <slot name="header" />
    </div>

    <div :class="$style.content">
      <slot name="content" />
    </div>

    <div :class="$style.footer">
      <slot name="footer">
        <div :class="$style.logo">
          <img :src="getLogoLink" alt="" />
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentTemplate',
  computed: {
    ...mapGetters(['getLogoLink']),
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    margin: 0 auto
    padding: 30px 15px
    display: flex
    flex-direction: column

    +respond-to('small')
      max-width: 340px

    +respond-to('medium')
      padding: 40px 0

  .header
    margin: 0 0 30px
    padding: 3px 0

  .content
    margin-bottom: 30px

    +respond-to('medium')
      margin-bottom: 50px

  .footer
    +flexbox
    +justify-content(center)

  .logo
    +size(96px, 66px)

    img
      width: 100%
</style>
